//如果使用者架構="AUTH"
export function getFilterCom(orgList, currentCId, rootId) {
  if (!Array.isArray(orgList)) return [];

  const companies = orgList.filter(
    (item) =>
      item.orgType === "COMPANY" && item.nodeStatus === "editable",
  );

  // 根節點：回傳全部公司 ID
  if (currentCId === rootId) {
    return companies.map((item) => item.value);
  }

  // 是公司本身，回傳自己
  const selfCompany = companies.find((item) => item.value === currentCId);
  if (selfCompany) {
    return [selfCompany.value];
  }

  // 其他情況：撈出所有公司中 level 含 currentCId 的（所有子孫公司）
  return companies
    .filter((item) => item.level.includes(currentCId))
    .map((item) => item.value);
}

//如果使用者架構="COMPANY"
export function getEditableSubTreeIds(startId, list) {
  const ids = [];

  // 內部遞迴函式
  const findChildren = (currentId) => {
    const node = list.find((item) => item.id === currentId);
    if (!node) return;

    // 如果該節點的狀態是 editable，就把它的 id 收進來
    if (node.nodeStatus === "editable") {
      ids.push(node.id);
    }

    // 在整個 list 中找出「以當前節點為父節點」的所有子節點，並繼續往下找
    const children = list.filter((item) => item.parentId === currentId);
    children.forEach((child) => findChildren(child.id));
  };

  findChildren(startId); // 從被點擊的節點開始找
  return ids;
}
